type CallbackParams = { code: string | undefined; state: string | undefined };

let _urlCallbackParams: CallbackParams | null = null;

export function stripCallbackUrl(): void {
  if (window.location.pathname !== '/callback') return;
  if (!window.location.search.includes('code=')) return;
  const url = new URL(window.location.href);
  _urlCallbackParams = {
    code: url.searchParams.get('code') ?? undefined,
    state: url.searchParams.get('state') ?? undefined,
  };
  url.searchParams.delete('code');
  url.searchParams.delete('state');
  window.history.replaceState({}, '', url.toString());
}

export function consumeCallbackParams(): CallbackParams | null {
  const callbackParams = _urlCallbackParams;
  _urlCallbackParams = null;
  return callbackParams;
}
